import React from 'react'

import TempLogo from "../../Photos/marioPumpkin.svg"
import WelcomeText from "../../Photos/Home-WelcomeText.svg"
import "./Welcome.scss"
import { Assignments } from '../Assignments/Assignments'
import { CodeAlong } from '../CodeAlong/CodeAlong'
import { Hours } from '../Hours/Hours'
import { Labs } from '../Labs and Sections/Labs'
import { Lectures } from '../Lectures/Lectures'
import { Resources } from '../Resources/Resources'
import { SRC } from '../SRC/SRC'
import { Staff } from '../Staff/Staff'

export class Welcome extends React.Component{

    render(){
        return(
                <section className="welcome welcome-page" id="home">
                    <div className="welcome-container">
                        <img  className="fixed-logo logo" src={TempLogo} alt="course logo" />
                        <div className ="home-container">
                            <div className="home-description-container">
                                <img className="welcome-text" src={WelcomeText} alt="welcome to CS15" />
                                <p className="main-description">
                                CS0150 is one of the introductory Computer Science courses offered at Brown University.
                                <br></br>
                                <br></br>
                                This course introduces students to Computer Science through object-oriented design and programming,
                                using Java and the JavaFX graphics library. You will use these tools for building interactive programs 
                                with graphical user interfaces. CS0150 reinforces concepts with practical exercises in weekly lab sessions 
                                and with challenging and engaging programming assignments, such as 
                                <span className = "doodle-color-text"> Doodle Jump</span> and <span className = "tetris-color-text">Tetris</span>!
                                <br></br>
                                <br></br>
                                There are no prerequisites for CS0150 and the course expects no prior programming experience.
                                </p>
                            </div>
                        </div>
                    </div>
                    <Assignments static={true}/>
                    <Lectures static={true}/>
                    <Labs static={true}/>
                    <CodeAlong static={true}/>
                    <Hours static={true}/>
                    <SRC static={true} />
                    <Resources static={true}/>
                    <Staff static={true}/>
                </section>
        )
    }

}